import { Dialog, DialogContent } from "@mui/material";

import AppButtons from "../AppButtons";
import { AppModalProps } from "./AppModal.props";
import { CloseOutlined as CloseButtonIcon } from "@mui/icons-material";
import BookingGetters from "../../../store/onlineBooking/getters";
import { useRef } from "react";

function AppModal({ children, handleClose, isOpen }: AppModalProps) {
  const AppSettings = BookingGetters.getAppSettings();
  const mainRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose(true);
          }
        }}
        open={isOpen}
        maxWidth="md"
        fullWidth
        TransitionProps={{
          onEntered: () => {
            const firstFocusable = mainRef.current?.querySelector<HTMLElement>(
              'input:not([type="hidden"]), select, textarea, button'
            );
            firstFocusable?.focus();
          },
        }}
        //  onBackdropClick={handleClose}
      >
        <DialogContent>
          <div className="flex flex-col h-full">
            <header
              className={
                "sticky top-0 h-full bg-white w-full float-right flex justify-end"
              }
            >
              <AppButtons
                disableElevation
                startIcon={<CloseButtonIcon />}
                color="clear"
                className="w-fit"
                clickHandler={handleClose}
                style={{
                  borderRadius: `${AppSettings?.buttonBorderRadius || 0}px`,
                }}
              >
                <></>
              </AppButtons>
            </header>
            <main ref={mainRef} className={"overflow-auto h-[75vh]"}>
              <div className={"h-full overflow-auto "}>{children}</div>
            </main>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export { AppModal };
